module.exports = __webpack_public_path__ + "static/media/icon_6.ee3bbc62.png";